(() => {
    'use strict';

    // Handle for uploading a recording file
    real.events.on('uploadedfile:stored', notification => {
        if (notification?.object?.uploadedfile?.upload_process_metadata?.token) {
            const token = notification.object.uploadedfile.upload_process_metadata.token;
            const widget = $('.widget-audio[data-recording-upload-token="' + token + '"]');
            if (widget.length > 0) {
                getUploadedFileAndPreview(widget, notification.object.uploadedfile.id);
            }
        }
    });

    /**
     * @param {*} widget
     * @param {*} uploadedFileId
     */
    const getUploadedFileAndPreview = (widget, uploadedFileId) => {
        real.ajax.json(real.baseUri + '/api/uploadedfile/' + uploadedFileId, {
            type: 'GET',
            success: (response) => {
                // Create or update a hidden input field for the uploaded file.
                if (widget.find('.upload-audio-wrapper input[name="uploadedfile"]').length > 0) {
                    widget.find('.upload-audio-wrapper input[name="uploadedfile"]').val(uploadedFileId);
                } else {
                    widget.find('.upload-audio-wrapper').append('<input type="hidden" name="uploadedfile" value="' + uploadedFileId + '">');
                }

                if (widget.find('.current-audio-wrapper .howspace-audio-player-initialized').length > 0) {
                    howspace.components.audioPlayer.destroy(widget);
                }

                widget.find('.current-audio-wrapper .howspace-audio-player')
                    .dataAndAttr('uploadedfile-id', uploadedFileId)
                    .dataAndAttr('is-stored', true)
                    .dataAndAttr('url', real.baseUri + '/uploadedfile/' + uploadedFileId + '/view')
                    .dataAndAttr('content-type', response.uploadedfile.content_type);

                howspace.components.audioPlayer.init(widget);

                widget.dataAndAttr('local-audio-file-id', uploadedFileId);

                howspace.animate(widget.find('.upload-audio-wrapper'), 'slideUp', 350, () => {
                    widget.find('.upload-audio-wrapper').removeAttr('style').addClass('d-none');
                    howspace.animate(widget.find('.current-audio-wrapper'), 'slideDown', 350, () => {
                        widget.find('.current-audio-wrapper').removeAttr('style').removeClass('d-none');

                        const saveBtn = widget.find('.save-widget-btn');
                        howspace.components.toolTip.enable(saveBtn);
                        howspace.components.toolTip.update(saveBtn, howspace.translate('common_remember_to_save'));
                        saveBtn.focus();
                    });
                });

                widget.find('.widget-footer .btn').prop('disabled', false);

                // In case of uploading a recording file in the view mode,
                // we need to save the information about the uploaded file to the widget.
                if (widget.data('widget-mode') === 'view') {
                    real.ajax.json(real.baseUri + '/api/widget/audio/' + widget.data('widget-id'), {
                        type: 'POST',
                        data: JSON.stringify(real.form.getDataPayload(widget)),
                    });
                }
            }
        });
    };

    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     * @param {*} uploadedFiles
     * @returns
     */
    const handleFileUploadCompleted = (modal, modalOpener, uploadedFiles) => {
        const file = uploadedFiles[0];
        const widget = $(modalOpener.closest('.widget-audio'));
        if (widget.length === 0 || !file || !file.id) {
            return;
        }

        getUploadedFileAndPreview(widget, file.id);

        howspace.components.modal.close(modal);
    };

    /**
     *
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initFileUploaderModal = (modal, modalOpener) => {
        modal.addEventListener(howspace.components.fileUploader.UPLOAD_COMPLETED, e => {
            handleFileUploadCompleted(modal, modalOpener, e.detail.uploadedFiles);
        });
    };

    const sendViewMinimumDelayInSeconds = 10;
    /**
     * @param {*} widget
     * @param {*} seconds
     * @returns
     */
    const sendView = (widget, seconds) => {
        const dataPayload = {
            listened_percentage: Math.min(100, Math.ceil(seconds / widget.data('local-audio-file-duration') * 100))
        };

        if (dataPayload.listened_percentage >= 90) {
            howspace.workspace.page.pathMode.handleUserHasInteracted(widget);
        }

        if (widget.data('last-view-sent-at') && widget.data('last-view-sent-at') > Date.now() - sendViewMinimumDelayInSeconds * 1000) {
            return;
        }

        widget.data('last-view-sent-at', Date.now());
        real.ajax.json(real.baseUri + '/api/widget/audio/' + widget.data('widget-id') + '/views', {
            type: 'POST',
            data: JSON.stringify(dataPayload)
        });
    };

    let recordTimerInterval = null;
    /**
     * @param {*} widget
     */
    const countDownAndStartRecording = (widget) => {
        widget.find('.widget-footer .btn').prop('disabled', true);

        const recordingContainer = widget.find('.recording');
        const recordingButtonsMessage = recordingContainer.find('.recording-buttons-message');
        const recordTimer = recordingButtonsMessage.find('.record-timer');
        const recordingCountdown = recordingContainer.find('.recording-countdown');
        const uploadOrRecordButtons = widget.find('.upload-or-record-buttons');

        if (recordTimerInterval) {
            clearInterval(recordTimerInterval);
        }

        const onMediaSuccess = (stream, type) => {
            uploadOrRecordButtons.addClass('d-none');
            recordingButtonsMessage.addClass('d-none');
            recordingContainer.removeClass('d-none');
            recordingCountdown.removeClass('d-none');

            setTimeout(() => {
                const previewRect = recordingContainer[0].getBoundingClientRect();
                if (previewRect.top < $('#top').height() || previewRect.bottom > window.innerHeight) {
                    // Either the top or the bottom of the recording preview is not fully visible, scroll to it.
                    howspace.scroller.scrollToElement(recordingContainer);
                }
            }, 100);

            recordingCountdown.prop('countdown', 3).animate(
                { countdown: 0 },
                {
                    duration: 3000,
                    easing: 'linear',
                    step: now => {
                        recordingCountdown.find('.count-down-text').html(Math.ceil(now));
                    },
                    complete: () => {
                        recordTimer.html('00:00');
                        recordingCountdown.addClass('d-none');
                        recordingButtonsMessage.removeClass('d-none');

                        const updateInterval = 1000;
                        let startTime = 0;
                        recordTimerInterval = setInterval(() => {
                            startTime += updateInterval;
                            const { hours, minutes, seconds } = howspace.mediaRecorder.calculateTime(startTime);
                            const format = howspace.mediaRecorder.formatTime(hours, minutes, seconds);
                            recordTimer.html(format);
                        }, updateInterval);

                        howspace.mediaRecorder.start(stream, type);
                    }
                }
            );
        }

        const onMediaError = () => {
            uploadOrRecordButtons.removeClass('d-none');
            recordingContainer.addClass('d-none');
            recordingCountdown.addClass('d-none');

            real.notification.show(howspace.translate('fileuploader_audio_recording_error'), 'danger');
        };

        howspace.mediaRecorder.startAudio(onMediaSuccess, onMediaError);
    };

    /**
     * @param {*} widget
     */
    const cancelRecording = (widget) => {
        const recordingContainer = widget.find('.recording');
        const uploadOrRecordButtons = widget.find('.upload-or-record-buttons');

        howspace.animate(recordingContainer, 'slideUp', 350, () => {
            recordingContainer.removeAttr('style');
            recordingContainer.addClass('d-none');
            uploadOrRecordButtons.removeClass('d-none');

            howspace.mediaRecorder.stop(() => {
                if (recordTimerInterval) {
                    clearInterval(recordTimerInterval);
                }
                widget.find('.widget-footer .btn').prop('disabled', false);
            });
        });
    };

    /**
     * @param {*} widget
     */
    const uploadRecording = (widget) => {
        const recordingContainer = widget.find('.recording');
        // Stop recording and start uploading
        howspace.mediaRecorder.stop(blob => {
            if (recordTimerInterval) {
                clearInterval(recordTimerInterval);
            }
            if (blob && blob.size > 0) {
                try {
                    const extension = howspace.mediaRecorder.getFileExtension(blob);

                    const formData = new FormData();
                    const token = real.uid();
                    formData.append('upload_process_metadata', JSON.stringify({
                        token: token
                    }));
                    formData.append('file', blob, `audio-recording${extension}`);
                    formData.append('file_type', blob.type);

                    real.ajax(real.baseUri + '/api/widget/audio/' + widget.data('widget-id') + '/uploadedfiles', {
                        type: 'POST',
                        data: formData,
                        dataType: 'json',
                        contentType: false,
                        processData: false,
                        success: () => {
                            widget.dataAndAttr('recording-upload-token', token);
                        }
                    });
                } catch (error) {
                    howspace.animate(recordingContainer, 'slideUp', 350, () => {
                        recordingContainer.removeAttr('style');
                        recordingContainer.addClass('d-none');
                        widget.find('.upload-or-record-buttons').removeClass('d-none');
                    });
                    real.notification.show(
                        howspace.translate('fileuploader_recording_error'),
                        'danger'
                    );
                }
            }
        });
    };

    const getViewStatisticsAndRenderChart = (widget, modal) => {
        real.ajax.json(real.baseUri + '/api/widget/audio/' + widget.data('widget-id') + '/views?grouped=1', {
            type: 'GET',
            success: function (response) {
                modal.find('.howspace-loader').remove();
                if (response.users_started_to_listen_audio) {
                    const headerTitle = modal.find('.modal-header .modal-title').text();
                    modal.find('.modal-header .modal-title').html(headerTitle + ' (' + response.users_started_to_listen_audio + ')');
                }

                const percentagesArr = [];
                let percentage = 0;
                while (percentage <= 100) {
                    percentagesArr.push(percentage + '%');
                    percentage++;
                }

                const brandColor = howspace.components.colorPicker.getPalette()[0];
                const backgroundColor = '#f0edfa';

                new Chart(modal.find('#listening-statistics-canvas')[0].getContext('2d'), {
                    type: 'line',
                    data: {
                        labels: percentagesArr,
                        datasets: [{
                            label: modal.data('users-translation'),
                            backgroundColor: backgroundColor,
                            borderColor: brandColor,
                            pointRadius: 0,
                            pointHitRadius: 10,
                            fill: 'start',
                            data: Object.keys(response.users_listened_audio_by_percentage).map(key => response.users_listened_audio_by_percentage[key])
                        }]
                    },
                    options: {
                        responsive: true,
                        plugins: {
                            title: { display: false }
                        },
                        scales: {
                            x: {
                                display: true,
                                ticks: {
                                    maxTicksLimit: 11
                                }
                            },
                            y: {
                                display: true,
                                ticks: {
                                    beginAtZero: true,
                                    stepSize: 1
                                }
                            }
                        }
                    }
                });
            }
        });
    }

    /**
     * @param {*} modal
     * @param {*} modalOpener
     */
    const initListeningStatisticsModal = (modal, modalOpener) => {
        modal = $(modal);
        const widget = $(modalOpener.closest('.widget-audio'));

        modal.on(howspace.components.modal.MODAL_OPENED, () => {
            howspace.chart.init(() => {
                getViewStatisticsAndRenderChart(widget, modal);
            });
        });
    };

    const initShareModal = (modal) => {
        modal = $(modal);

        const widgetId = $(modal).data('widget-id');
        const widget = $('.widget-audio[data-widget-id="' + widgetId + '"]');
        if (widget.length === 0) {
            return;
        }

        const audioPlayer = widget.find('.howspace-audio-player');
        if (audioPlayer.length === 0) {
            return;
        }

        if (audioPlayer.data('current-time')) {
            const timeButton = modal.find('.shared-link-btn[data-with-time="1"]');
            const radioWrapper = timeButton.closest('.howspace-form-radio-button');
            const startAtSeconds = Math.floor(audioPlayer.data('current-time')) || 0;

            timeButton.dataAndAttr('start-at-seconds', startAtSeconds);
            timeButton.val(startAtSeconds);

            radioWrapper.find('.howspace-form-label-text span').text(howspace.translate('audio_copy_link_to_current_moment', {
                time: howspace.mediaShare.formatTimeInput(startAtSeconds)
            }));
            timeButton.prop('disabled', startAtSeconds === 0);
            timeButton.prop('checked', startAtSeconds > 0);
            radioWrapper.toggleClass('disabled', startAtSeconds === 0);
        }

        modal.find('.copy-link-btn').on('click', async (e) => {
            const checkedRadio = modal.find('.shared-link-btn:checked');
            const sharedLink = howspace.mediaShare.getSharedLink(checkedRadio);

            await real.copyToClipboard(sharedLink, () => {
                howspace.components.modal.close(modal);
                howspace.dispatchEvent(widget, howspace.widgets.audio.AUDIO_SHARE_LINK_COPIED, {
                    sharedLink: sharedLink
                });
            }, () => {
                howspace.components.modal.close(modal);
                howspace.dispatchEvent(widget, howspace.widgets.audio.AUDIO_SHARE_LINK_COPY_FAILED);
            });
        });
    };

    howspace.widgets.audio = {
        AUDIO_SHARE_LINK_COPIED: 'audio-share-link-copied',
        AUDIO_SHARE_LINK_COPY_FAILED: 'audio-share-link-copy-failed',
        initView: widget => {
            widget.find('.record-audio-btn').on('click', () => {
                countDownAndStartRecording(widget);
            });

            widget.find('.cancel-recording-btn').on('click', () => {
                cancelRecording(widget);
            });

            widget.find('.upload-recording-btn').on('click', () => {
                uploadRecording(widget);
            });

            widget.on(howspace.components.audioPlayer.AUDIO_PLAY, e => {
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.components.audioPlayer.AUDIO_PAUSE, e => {
                widget.removeData('last-view-sent-at');
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.components.audioPlayer.AUDIO_TIME_UPDATED, e => {
                if (!e.player.paused()) {
                    sendView(widget, Math.ceil(e.detail.player.currentTime()));
                }
            });

            widget.on(howspace.components.audioPlayer.AUDIO_ENDED, e => {
                widget.removeData('last-view-sent-at');
                sendView(widget, Math.ceil(e.detail.player.currentTime()));
            });

            widget.on(howspace.widgets.audio.AUDIO_SHARE_LINK_COPIED, e => {
                real.notification.show(howspace.translate('audio_shared_link_copied'), 'success');
            });

            widget.on(howspace.widgets.audio.AUDIO_SHARE_LINK_COPY_FAILED, () => {
                real.notification.show(howspace.translate('common_failed_to_copy_link'), 'danger');
            });

            howspace.transcript.init(widget);
        },
        destroyView: widget => {
            howspace.transcript.destroy(widget);
        },
        initEdit: widget => {
            widget.find('.delete-audio-btn').on('click', () => {
                howspace.animate(widget.find('.current-audio-wrapper'), 'slideUp', 350, () => {
                    howspace.components.audioPlayer.destroy(widget);
                    widget.find('.current-audio-wrapper').removeAttr('style').addClass('d-none');
                    widget.find('.upload-audio-wrapper .recording').addClass('d-none');
                    widget.find('.upload-audio-wrapper').find('.upload-or-record-buttons').removeClass('d-none');

                    if (widget.find('.upload-audio-wrapper input[name="uploadedfile"]').length > 0) {
                        widget.find('.upload-audio-wrapper input[name="uploadedfile"]').remove();
                    } else {
                        widget.find('.upload-audio-wrapper').append('<input type="hidden" name="uploadedfile" value="">');
                    }

                    howspace.animate(widget.find('.upload-audio-wrapper'), 'slideDown', 350, () => {
                        widget.find('.upload-audio-wrapper').removeAttr('style').removeClass('d-none');
                    });
                });
            });

            widget.find('.record-audio-btn').on('click', () => {
                countDownAndStartRecording(widget);
            });

            widget.find('.cancel-recording-btn').on('click', () => {
                cancelRecording(widget);
            });

            widget.find('.upload-recording-btn').on('click', () => {
                uploadRecording(widget);
            });
        },
        destroyEdit: widget => {
            // Empty for now.
        },
        initFileUploaderModal: initFileUploaderModal,
        initListeningStatisticsModal: initListeningStatisticsModal,
        initShareModal: initShareModal,
    };
})();
